export default __webpack_public_path__ + "static/media/louis-vuitton.939cb0b1.jpg";